/**
 * 首页
 * 2017-12-6
 */
"use strict";
angular.module("basicInformationModule", [
    "basicInformationRouter", //路由
    "pwdStrengthModule"
]).
controller("basicInformationCtrl", ["$scope", '$rootScope', "httpService", "$validation", "$interval", "$stateParams", "$state", "modalDialog", "$q", "$element", '$timeout', function($scope, $rootScope, httpService, $validation, $interval, $stateParams, $state, modalDialog, $q, $element, $timeout) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            verificationCode: "/mcnww/web/code/image.do?V=12345678",
            send: false,
            flag: false,
        };
        $scope.info = {
            mobile: '',
            userType: $stateParams.userType
        };
        $scope.data = {
            listData: [],
            alertCode: false,
            iphoneTrue: false, //验证手机
            userAuthentication: false, //验证用户名是否已注册
            same: false, //判断密码是否一致
            validCodeTrue: false, //判断手机验证码是否错误
            captchaToken: false, //验证图形验证码是否错误
        };
    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {
        requestData();
        loadEncryptionLib().then(function() {
            encryptionMethods();
        });
        // console.log($scope.status.verificationCode);
    }
    /**
     * [encryptionMethods description] 加密方法
     * @return {[type]} [description]
     */
    function encryptionMethods() {
        $.ajax({
            url: "/mcnww/web/user/publicKey.do",
            dataType: "text",
            success: function(data) {
                $("#encryption").remove();
                $("body").append("<script id='encryption'>" + data + "</script>");
            }
        });
    }
    /**
     * [loadEncryptionLib description] 加载加密依赖文件
     * @return {[type]} [description]
     */
    function loadEncryptionLib() {
        var deffer = $q.defer();
        LazyLoad.js(["static/rsa/RSA.js", "static/rsa/BigInt.js", "static/rsa/Barrett.js"], function() {
            deffer.resolve();
        });
        return deffer.promise;
    }
    /**
     * [requestData description] 初始化
     */
    function requestData() {
        var params = $rootScope.informationRetained;
        if (!params) return;
        $scope.info.userName = params.userName;
        $scope.info.mobile = params.mobile;
        $scope.info.MbValidCode = params.MbValidCode;
    }
    $scope.savePwd = function() {
        if ($scope.data.captchaToken) {
            $scope.updateImg();
            $element.find('.captchaToken').focus();
            $element.find('.captchaToken').blur();
            return;
        }
        if($scope.status.modes<2&&$scope.info.password!=undefined&&$scope.info.password.length>0){
            $element.find('.passWordTrue')[0].focus();
            $element.find('.passWordTrue')[0].blur();
            return;
        }
        if ($scope.info.password != $scope.info.confirmPassword) {
            $element.find('.passWordTrue')[0].focus();
            $element.find('.passWordTrue')[0].blur();
            return;
        } else if ($scope.data.iphoneTrue) {
            $element.find('.iphoneCard')[0].focus();
            $element.find('.iphoneCard')[0].blur();
            return;
        } else if ($scope.data.validCodeTrue) {
            $element.find('.validCodeTrue').focus();
            $element.find('.validCodeTrue').blur();
            return;
        } else if ($scope.data.captchaToken) {
            $element.find('.captchaToken').focus();
            $element.find('.captchaToken').blur();
            return;
        } else if ($scope.data.userAuthentication) {
            $element.find('.userAuthentication').focus();
            $element.find('.userAuthentication').blur();
            return;
        }
        $validation.validate($scope.basicInformation).success(function() {
            httpService.http('/mcnww/web/code/valid.do', { name: 'MbValidCode', param: $scope.info.MbValidCode }, 'get').then(function(data) {
                if (data.status == 'n') {
                    // sessionStorage.setItem('requestToken',data.requestToken);
                    $scope.data.validCodeTrue = true;
                } else {
                    var params = angular.copy($scope.info);
                    params.password = encryptedString(bodyRSA(), params.password);
                    params.confirmPassword = encryptedString(bodyRSA(), params.confirmPassword);
                    $rootScope.informationRetained = params;
                    if ($stateParams.userType == 0) {
                        var orgUrlName = "register.authentication";
                        $state.go(orgUrlName, { userType: 0 });
                    } else {
                        var pgcUrlName = 'register.pgcauthentication';
                        $state.go(pgcUrlName, { userType: 1 });
                    }
                }
            });

        }).error(function() {

            angular.invalidPosition($scope.basicInformation, $element);
        });
    };
    /**
     * [singleValidate description] 失焦事件
     * @return {[type]} [description]
     */
    // $scope.singleValidate = function(name) {
    //     $validation.validate($scope.basicInformation[name]);
    //     $scope.isShowTipsB = false;
    //     if (name == "confirmPassword") {
    //         $scope.isShowTipsC = false;
    //     }
    // };
    $scope.cancel = function() {
        var pgcUrlName = 'register';
        $state.go(pgcUrlName);
    };
    /**
     * [updateImg description] 更新验证码
     * @return {[type]} [description]
     */
    $scope.updateImg = function() {
        var imgArray = $scope.status.verificationCode.split("=");
        imgArray[1] = Math.random();
        $scope.status.verificationCode = imgArray.join("=");
    };
    /**
     * [SMScode description] 短信验证码 发送
     * @return {[type]} [description]
     */
    $scope.SMScode = function() {
        var params = {
            mobile: $scope.info.mobile
        };
        httpService.http("/mcnww/web/code/sms.do", params, "post", true, true).then(function(result) {
            if (!result.success) {
                modalDialog.success(result.message, "success", false, function() {}, function() {}, '', 'getCodeError');

            } else {
                $scope.status.send = true;
                countDown();
                modalDialog.success("验证码已发送至您的手机，请注意查收", "success", false, function() {}, function() {}, '', 'getCodeSuccess');
                $scope.data.alertCode = true;
                $timeout(function() {
                    $scope.data.alertCode = false;
                }, 1500);
            }
        });
    };
    /**
     * [regularIf description] 判断是否显示正确图标
     * @return {[type]} [description]
     */
    $scope.regularIf = function(key, value) {
        switch (key) {
            case 1: //用户名-ok
                $scope.isShowTipsA = false;
                $scope.data.isShowTipsAa = false;
                $scope.data.userAuthentication = false;
                var uesrLength = $element.find('.table>ul>li:first-child>.tips');
                uesrLength.text().length > 8 ? uesrLength.addClass('notPaddintTop') : uesrLength.removeClass('notPaddintTop');
                break;
            case 2: //登录密码
                $scope.isShowTipsB = false;
                $scope.data.isShowTipsBb = false;
                var passwordLength = $element.find('.table>ul>li:nth-child(2)>.tips');
                passwordLength.text().length > 8 ? passwordLength.addClass('notPaddintTop') : passwordLength.removeClass('notPaddintTop');
                // $scope.data.minPassword = false;
                break;
            case 3: //确认密码
                $scope.isShowTipsC = false;
                $scope.data.isShowTipsCc = false;
                $scope.data.same = false;
                var reallyPassword=$element.find('.table>ul>li:nth-child(3)>.tips');
                reallyPassword.text().length > 8 ? reallyPassword.addClass('notPaddintTop') : reallyPassword.removeClass('notPaddintTop');
                break;
            case 4: //手机号
                $scope.data.iphoneTrue = false;
                $scope.isShowTipsD = false;
                $scope.data.isShowTipsDd = false;
                break;
            case 5: //图形验证码
                $scope.isShowTipsE = false;
                $scope.data.isShowTipsEe = false;
                $scope.data.captchaToken = false;
                break;
            case 6: //手机验证码
                $scope.data.validCodeTrue = false;
                $scope.isShowTipsF = false;
                $scope.data.isShowTipsFf = false;
        }
        $validation.validate($scope.basicInformation[value]).success(function() {
            switch (key) {
                case 1:
                    httpService.http('/mcnww/web/user/existsValid.do', { name: 'userName', param: $scope.info.userName }, 'post').then(function(data) {
                        if (data.status == 'n') {
                            $scope.data.userAuthentication = true;
                        } else {
                            $scope.data.isShowTipsAa = true;
                        }
                    });
                    break;
                case 2:
                    if($scope.status.modes>1){
                        $scope.data.isShowTipsBb = true;
                    }
                    if (!$scope.info.confirmPassword) return;
                    if ($scope.info.password != $scope.info.confirmPassword) {
                        $scope.data.same = true;
                        $scope.data.isShowTipsCc = false;
                    } else {
                        $scope.data.same = false;
                        $scope.data.isShowTipsCc = true;
                    }
                    break;
                case 3:
                    if ($scope.info.password != $scope.info.confirmPassword) {
                        $scope.data.same = true;
                        $scope.data.isShowTipsCc = false;
                    } else {
                        $scope.data.same = false;
                        $scope.data.isShowTipsCc = true;
                    }
                    break;
                case 4:
                    httpService.http('/mcnww/web/user/existsValid.do', { name: 'mobile', param: $scope.info.mobile }, 'post').then(function(data) {
                        if (data.status == 'n') {
                            $scope.data.iphoneTrue = true;
                        } else {
                            $scope.data.isShowTipsDd = true;
                        }
                    });
                    break;
                case 5:
                    httpService.http('/mcnww/web/code/valid.do', { name: 'captchaToken', param: $scope.info.captchaToken }, 'get').then(function(data) {
                        if (data.status == 'n') {
                            $scope.data.captchaToken = true;
                            $scope.updateImg();
                        } else {
                            $scope.data.isShowTipsEe = true;
                        }
                    });
                    break;
                case 6:
                    httpService.http('/mcnww/web/code/valid.do', { name: 'MbValidCode', param: $scope.info.MbValidCode }, 'get').then(function(data) {
                        if (data.status == 'n') {
                            $scope.data.validCodeTrue = true;
                        } else {
                            $scope.data.isShowTipsFf = true;
                        }
                    });
                    break;
            }
        });

    };

    /**
     * [countDown description] 倒计时
     * @return {[type]} [description]
     */
    var timer = null;

    function countDown() {
        var time = 60;
        $scope.status.send = true;
        $interval.cancel(timer);
        timer = $interval(function() {
            time--;
            $scope.status.time = time;
            if (time === 0) {
                $scope.status.send = false;
                $scope.updateImg();
                $interval.cancel(timer);
            }
        }, 1000);
    }
    /**
     * [comparison description] 比对
     * @return {[type]} [description]
     */
    // $scope.comparison = function(key) {
    //     key=!key;
    //     console.log(key);
    //     // if ($scope.info.password != $scope.info.confirmPassword) {
    //     //     $scope.status.flag = true;
    //     // } else {
    //     //     $scope.status.flag = false;
    //     // }
    // };

}]);
